document.documentElement.classList.add('ny-js');
function updateNayeloOverlay(){
  document.documentElement.classList.toggle('ny-overlay-open',Boolean(document.querySelector('.ny-menu-dialog[open],.ny-quick-dialog[open]')));
}
function containNayeloDialogFocus(dialog){
  dialog.addEventListener('keydown',event=>{
    if(event.key!=='Tab')return;
    const controls=Array.from(dialog.querySelectorAll('button,a[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(el=>!el.disabled&&el.getClientRects().length);
    const first=controls[0],last=controls[controls.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
  });
}
function initNayelo(root=document){
  root.querySelectorAll('[data-nayelo-header]').forEach(header=>{
    if(header.dataset.initialized)return;
    header.dataset.initialized='true';
    const button=header.querySelector('[data-ny-menu]');
    const menu=header.querySelector('#ny-mobile-menu');
    if(button&&menu&&typeof menu.showModal==='function'){
      containNayeloDialogFocus(menu);
      const close=()=>menu.close();
      button.addEventListener('click',()=>{menu.showModal();button.setAttribute('aria-expanded','true');updateNayeloOverlay()});
      menu.querySelector('[data-ny-menu-close]').addEventListener('click',close);
      menu.addEventListener('click',e=>{if(e.target.closest('a'))close()});
      menu.addEventListener('click',e=>{if(e.target===menu)close()});
      menu.addEventListener('close',()=>{button.setAttribute('aria-expanded','false');updateNayeloOverlay();button.focus()});
      const mobile=window.matchMedia('(max-width:749px)');
      mobile.addEventListener('change',()=>{if(!mobile.matches&&menu.open)close()});
    }
    header.querySelectorAll('[data-ny-country]').forEach(select=>select.addEventListener('change',()=>select.form.requestSubmit()));
  });
}
initNayelo();
document.addEventListener('shopify:section:load',e=>initNayelo(e.target));

function initNayeloAdvanced(root=document){
  root.querySelectorAll('[data-ny-showcase]').forEach(section=>{
    if(section.dataset.advancedReady)return;section.dataset.advancedReady='true';
    const cards=Array.from(section.querySelectorAll('[data-ny-card]')),results=section.querySelector('[data-ny-results]'),empty=section.querySelector('[data-ny-empty]');
    const finder=section.querySelector('[data-ny-finder]'),purpose=section.querySelector('[data-ny-purpose]'),budget=section.querySelector('[data-ny-budget]'),reset=section.querySelector('[data-ny-reset]');
    const disclosure=section.querySelector('#ny-finder');
    if(disclosure&&location.hash!=='#ny-finder')disclosure.open=false;
    const more=section.querySelector('[data-ny-more]'),remaining=section.querySelector('[data-ny-remaining]');
    const initialLimit=more?8:cards.length;
    let active='all',visibleLimit=initialLimit;
    const applyFilters=()=>{
      const maximum=budget&&budget.value!=='all'?Number(budget.value):Infinity;
      let count=0,shown=0;
      cards.forEach(card=>{
        const category=active==='all'||card.dataset.groups.split(/\s+/).includes(active);
        const price=card.dataset.price?Number(card.dataset.price):null;
        const show=category&&(maximum===Infinity||(price!==null&&price<=maximum));
        if(show)count++;
        const visible=show&&shown<visibleLimit;card.hidden=!visible;if(visible)shown++;
      });
      section.querySelectorAll('[data-ny-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item.dataset.nyFilter===active)));
      if(results)results.textContent=((shown<count?results.dataset.showing:(count===1?results.dataset.one:results.dataset.many))||results.dataset.many||'[count]').replace('[shown]',String(shown)).replace('[count]',String(count));
      if(more)more.hidden=shown>=count;
      if(remaining){remaining.hidden=shown>=count;remaining.textContent=(remaining.dataset.label||'[count]').replace('[count]',String(count-shown))}
      if(empty)empty.hidden=count>0;
      if(reset)reset.hidden=active==='all'&&maximum===Infinity;
    };
    section.querySelectorAll('[data-ny-filter]').forEach(button=>button.addEventListener('click',()=>{
      active=button.dataset.nyFilter;visibleLimit=initialLimit;if(purpose)purpose.value=active;applyFilters();
    }));
    if(finder)finder.addEventListener('submit',event=>{
      event.preventDefault();active=purpose.value;visibleLimit=initialLimit;applyFilters();
      results.tabIndex=-1;results.focus({preventScroll:true});results.scrollIntoView({block:'center',behavior:'instant'});
    });
    if(reset)reset.addEventListener('click',()=>{active='all';visibleLimit=initialLimit;if(purpose)purpose.value='all';if(budget)budget.value='all';applyFilters()});
    if(more)more.addEventListener('click',()=>{visibleLimit+=8;applyFilters()});
    applyFilters();
    const dialog=section.querySelector('dialog');let opener=null;
    if(dialog&&typeof dialog.showModal==='function'){
      containNayeloDialogFocus(dialog);
      section.querySelectorAll('[data-ny-quick]').forEach(button=>button.addEventListener('click',()=>{
        opener=button;dialog.querySelector('[data-ny-modal-title]').textContent=button.dataset.title||'';
        dialog.querySelector('[data-ny-modal-status]').textContent=button.dataset.status||'';
        dialog.querySelector('[data-ny-modal-description]').textContent=button.dataset.description||'';
        const price=dialog.querySelector('[data-ny-modal-price]');price.textContent=button.dataset.price||'';price.hidden=!button.dataset.price;
        const img=dialog.querySelector('[data-ny-modal-image]');img.parentElement.hidden=!button.dataset.image;if(button.dataset.image){img.srcset=button.dataset.imageSrcset||'';img.src=button.dataset.image;img.alt=button.dataset.title||''}
        const link=dialog.querySelector('[data-ny-modal-link]');link.href=button.dataset.url;link.textContent=button.dataset.linkLabel;
        dialog.showModal();updateNayeloOverlay();
      }));
      dialog.querySelector('[data-ny-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
      dialog.addEventListener('close',()=>{updateNayeloOverlay();if(opener)opener.focus()});
    }else{section.querySelectorAll('[data-ny-quick]').forEach(button=>button.hidden=true)}
  });
  root.querySelectorAll('[data-ny-document]').forEach(section=>{
    if(section.dataset.tocReady)return;section.dataset.tocReady='true';
    const headings=section.querySelectorAll('[data-ny-document-body] h2'),toc=section.querySelector('[data-ny-toc]'),links=section.querySelector('[data-ny-toc-links]');
    if(headings.length<3||!toc||!links)return;
    headings.forEach((heading,index)=>{if(!heading.id)heading.id='ny-topic-'+index;const a=document.createElement('a');a.href='#'+heading.id;a.textContent=heading.textContent;links.appendChild(a)});toc.hidden=false;
  });
}
initNayeloAdvanced();
document.addEventListener('shopify:section:load',event=>initNayeloAdvanced(event.target));


document.addEventListener('click',event=>{
  const entry=event.target.closest('a[href]');
  const finder=document.getElementById('ny-finder');
  if(!entry||!finder)return;
  const target=new URL(entry.href,location.href);
  if(target.origin!==location.origin||target.pathname.replace(/\/$/,'')!==location.pathname.replace(/\/$/,'')||target.hash!=='#ny-finder')return;
  event.preventDefault();
  history.replaceState(null,'','#ny-finder');
  openNayeloFinder(true);
});
function openNayeloFinder(focus=false){
  const finder=document.getElementById('ny-finder');
  if(!finder||location.hash!=='#ny-finder')return;
  finder.open=true;
  requestAnimationFrame(()=>{
    finder.scrollIntoView({block:'start',behavior:'instant'});
    if(focus)finder.querySelector('summary').focus({preventScroll:true});
  });
}
openNayeloFinder();
window.addEventListener('hashchange',()=>openNayeloFinder());
window.addEventListener('load',()=>openNayeloFinder());

function initNayeloPersonalisation(root=document){
  root.querySelectorAll('[data-ny-personalisation]').forEach(panel=>{
    if(panel.dataset.ready)return;
    panel.dataset.ready='true';
    const input=panel.querySelector('[data-ny-name-input]'),output=panel.querySelector('[data-ny-name-output]');
    input.addEventListener('input',()=>{
      output.textContent=input.value.trim()||output.dataset.placeholder;
      input.setCustomValidity(input.required&&!input.value.trim()?input.dataset.invalidMessage:'');
    });
  });
}
initNayeloPersonalisation();
document.addEventListener('shopify:section:load',event=>initNayeloPersonalisation(event.target));
